import { defineComponent, ref, shallowRef, useTemplateRef, watch, onUnmounted, openBlock, createBlock, unref, withCtx, createVNode, withModifiers, createTextVNode, nextTick } from 'vue';
import { ElForm, ElInput } from 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
import '@ssml-editor/core';
import { Button, EditorUtils } from '@ssml-editor/vue';
/* empty css                                                                                                                                                   */
/* empty css                                                     */
import '@ssml-editor/modules';
import Popover from '../../../component/popover/popover.js';
import '../../module/phoneme/alphabet.enum.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { E as Editor } from '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';
import { SUB_TYPE } from '../../module/sub/constant.js';
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { AliasMenuService } from './alias-menu-service.js';
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
import '@ssml-editor/base';
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "alias-menu",
  props: {
    editor: {}
  },
  setup(__props) {
    const props = __props;
    const popoverVisible = ref(false);
    const aliasInputValue = ref("");
    const aliasMenuService = shallowRef();
    const aliasInputRef = useTemplateRef("alias-input");
    function show(callback) {
      popoverVisible.value = true;
      callback && nextTick(callback);
    }
    function hide(callback) {
      popoverVisible.value = false;
      callback && nextTick(callback);
    }
    async function menuClickHandler() {
      const editor = props.editor;
      if (editor) {
        aliasMenuService.value ??= new AliasMenuService(editor);
        EditorUtils.trimSelection(editor);
        if (!aliasMenuService.value.isDisabled()) {
          const data = aliasMenuService.value.getSerializedNode();
          if (data) {
            aliasInputValue.value = data.alias;
          } else {
            aliasInputValue.value = "";
          }
          show(() => {
            aliasInputRef.value?.focus();
          });
        }
      }
    }
    function submitHandler() {
      const node = aliasMenuService.value?.setNode(aliasInputValue.value);
      hide(() => {
        setTimeout(() => {
          const editor = props.editor;
          if (node && editor) {
            const path = EditorUtils.findPath(editor, node);
            if (path) {
              const point = Editor.end(editor, path);
              editor.select(point);
            }
          }
        });
      });
    }
    function ssmlMarkClickHandler(_eventName, _editor, elem) {
      if (elem.type === SUB_TYPE) {
        aliasMenuService.value = void 0;
        menuClickHandler();
      }
    }
    watch(
      () => props.editor,
      (newValue, oldValue) => {
        oldValue?.off("ssml-mark-click", ssmlMarkClickHandler);
        newValue?.on("ssml-mark-click", ssmlMarkClickHandler);
      },
      {
        immediate: true
      }
    );
    onUnmounted(() => {
      props.editor?.off("ssml-mark-click", ssmlMarkClickHandler);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Popover), {
        modelValue: popoverVisible.value,
        "onUpdate:modelValue": ($event) => popoverVisible.value = $event,
        width: 200,
        onSubmit: submitHandler
      }, {
        reference: withCtx(() => [
          createVNode(unref(Button), {
            "icon-class": "iconfont-ssml-editor icon-ssml-editor-bieming",
            onClick: menuClickHandler
          }, {
            default: withCtx(() => [
              createTextVNode("别名")
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createVNode(unref(ElForm), {
            onSubmit: withModifiers(submitHandler, ["prevent"])
          }, {
            default: withCtx(() => [
              createVNode(unref(ElInput), {
                type: "text",
                ref: "alias-input",
                modelValue: aliasInputValue.value,
                "onUpdate:modelValue": ($event) => aliasInputValue.value = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onUpdate:modelValue"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=alias-menu.vue.js.map
